import { useCombinedThemeMode } from "@smartsheet/sds-theme-internal";
import React from "react";
import { layers } from "../../constants/layers";
import { noop } from "../../constants/noop";
import { BlanketStyled } from "./styled/BlanketStyled";
/**
 * The main purpose of the blanket component is to provide the overlay layer for components such as
 * a modal dialog or menu.
 */
export var Blanket = function Blanket(_ref) {
  var _ref$canClickThrough = _ref.canClickThrough,
    canClickThrough = _ref$canClickThrough === void 0 ? false : _ref$canClickThrough,
    className = _ref.className,
    _ref$isTinted = _ref.isTinted,
    isTinted = _ref$isTinted === void 0 ? false : _ref$isTinted,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? noop : _ref$onClick,
    _ref$onDoubleClick = _ref.onDoubleClick,
    onDoubleClick = _ref$onDoubleClick === void 0 ? noop : _ref$onDoubleClick,
    clientId = _ref.clientId,
    _ref$zIndex = _ref.zIndex,
    zIndex = _ref$zIndex === void 0 ? layers.blanket : _ref$zIndex;
  var themeMode = useCombinedThemeMode();
  return /*#__PURE__*/React.createElement(BlanketStyled, {
    canClickThrough: canClickThrough,
    className: className,
    "data-client-id": clientId,
    isTinted: isTinted,
    onClick: canClickThrough ? undefined : onClick,
    onDoubleClick: canClickThrough ? undefined : onDoubleClick,
    themeMode: themeMode,
    zIndex: zIndex
  });
};
//# sourceMappingURL=Blanket.js.map